module.exports = __webpack_public_path__ + "img/1571240104.05978aae.jpg";